import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import NoClient from "../../../../../static/images/no-client.svg";
import { getRoles } from "../../../../Redux/reducer/session";
import { moduleAction } from "../../../utils/functions";
import { MOD_PROVID, WRITE } from "../../../../permissions/";

const BlankProvider = ({ onClick }) => {
  const roles = useSelector(getRoles);

  const history = useHistory();

  const handleClick = () => {
    onClick ? onClick() : history.push("/bscadministrator/providers/add");
  };

  return (
    <div id="no-client">
      <img src={NoClient} className="no-client-img" />
      <h3 className="center-text mb-3">
        El sistema no posee proveedores registrados.
      </h3>
      <p className="no-register">
        Estimado usuario, en este momento el sistema no presenta clientes
        registrados.
      </p>
      <p className="no-register-option">
        Puede agregar un usuario ingresando en el botón de agregar cliente en la
        parte inferior.
      </p>
      <div className="no-client-line"></div>
      <div className="form-actions clearfix">
        {moduleAction(roles, MOD_PROVID, WRITE) && (
          <div className="add-button flex-element">
            <button
              id="saveProvider"
              className="button button--pill btnAgregar"
              onClick={handleClick}
            >
              Agregar Cliente
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlankProvider;
